"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaTicketServiceProperty = exports.ctaTicketServiceDefinition = void 0;
exports.ctaTicketServiceDefinition = {
    view: { label: 'Ticket service' },
    constraints: [
        {
            name: 'providers',
            argument: ['Eventbrite'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'service',
    multiple: false,
    name: 'cta-ticket-service',
};
const isCtaTicketServiceProperty = (prop) => {
    return prop.name === exports.ctaTicketServiceDefinition.name;
};
exports.isCtaTicketServiceProperty = isCtaTicketServiceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXRpY2tldC1zZXJ2aWNlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY3RhLXRpY2tldC1zZXJ2aWNlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGdCQUFnQixFQUFFO0lBQ2pDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUMsWUFBWSxDQUFDO1NBQ3pCO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLG9CQUFvQjtDQUNLLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==